import { FC, useEffect, useRef, useState } from 'react'
import classnames from 'classnames'
import Modal from '../../common/components/modal'
import { Button, Card, CardContent, Text } from '@mytours/components'
import { fetchAudio } from 'mobile_web/common_lib/utils'
import strings from 'mobile_web/strings'
import '../styles/answerModal.less'

interface AnswerModalProps {
	isOpen: boolean
	onClose: () => void
	imageSrc?: string
	audioSrc?: string
	text?: string
	isCorrect: boolean
}

const AnswerModal: FC<AnswerModalProps> = ({ isOpen, onClose, isCorrect, imageSrc, text, audioSrc }) => {
	const [resolvedAudioSrc, setResolvedAudioSrc] = useState(null)

	useEffect(() => {
		if (audioSrc && audioSrc.includes('/quality_7/')) {
			fetchAudio(audioSrc).then(audio => {
				if (audio) {
					setResolvedAudioSrc(audio)
				}
			})
		}
	}, [audioSrc])

	return (
		<Modal
			isOpen={isOpen}
			onDidDismiss={onClose}
			preventNavigate={true}
			cssClass={classnames('answer-modal', { '-correct': isCorrect })}
		>
			<Card variant="ios">
				<CardContent>
					{imageSrc && (
						<div className="answer-modal-image">
							<img src={imageSrc} alt="" />
						</div>
					)}
					<div className={classnames('answer-modal-text', { '-no-image': !imageSrc })}>
						<i className={`far fa-${isCorrect ? 'circle-check' : 'circle-xmark'}`} />
						<Text variant="inherit">{text}</Text>
					</div>
					<Button variant="clear" aria-label={strings.close} onClick={onClose}>
						{strings.close}
					</Button>
					{resolvedAudioSrc && isOpen ? (
						<audio
							src={resolvedAudioSrc}
							ref={ref => {
								if (ref) {
									ref.play()
								}
							}}
						/>
					) : null}
				</CardContent>
			</Card>
		</Modal>
	)
}

export default AnswerModal
